import { defaultCRAFormFields } from './cra-default-translations';

export const translationsData = {
  en: {
    metaData: {
      layout: 'docs',
      noIndex: true,
      'meta-title': 'Prescreen Opt-Out',
      'meta-description': 'Prescreen Opt-Out',
      'hide-search': 'true',
      'subnav-filters-hidden': 'true',
    },
    craEntityName: 'Plaid Check',
    pageHeader: 'Prescreen Opt-Out',
    introHeader: 'Introduction',
    requestType: 'Prescreen Opt-Out',
    intro: `<p>Under the Fair Credit Reporting Act, creditors may use your consumer file information as the basis for sending you firm offers of credit. These offers are also known as “prescreened” offers. You may opt out of receiving such offers based on Plaid Check reports by providing your personal information requested below.</p>
            <p>Please note that certain fields are mandatory, and some are optional. The optional fields allow us to better match your identity and process your request. In certain circumstances we may be unable to process your request. In these cases, we will inform you via the email you provide on this form. For more information on your rights under federal and state law, please see the Consumer Rights Notices <a href="https://plaid.com/plaid-check-consumer-report/notices-of-consumer-rights/">linked here</a> for your convenience.</p>`,
    ...defaultCRAFormFields,
    phone: {
      label: 'Phone (optional)',
      error: 'Invalid phone number',
      optional: true,
    },
    dateOfBirth: {
      label: 'Date of birth (MM/DD/YYYY) (optional)',
      error: 'Invalid date of birth',
      optional: true,
    },
    ssnLastFour: {
      label: 'Last 4 digits of SSN or ITIN (optional)',
      error: 'Invalid last 4 digits of SSN (or ITIN)',
      optional: true,
    },
    // Omit requestDetails field as free text box is not necessary for prescreen opt-out
    requestDetails: null,
  },
};
